let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c5x8o")).then(() => parcelRequire('ajKSQ'));